import { Product } from '../models/product';

export function canBuyProduct(product: Product, allowOutOfStockOrdering: boolean = false): boolean {
  if (!product) {
    return false;
  }

  // If product doesn't have a price, it can't be bought.
  if (!product.price) {
    return false;
  }

  // Ok, we have a product and we have a price. If user may order items that are out of stock, we can return true.
  if (allowOutOfStockOrdering) {
    return true;
  }

  // Check if this product is still in stock (current or future)
  if (product && product.stock && product.stock.length) {
    const currentStockQuantity = product.stock
      .filter((stock) => stock.type === 'current')
      .map((stock) => stock.quantity)
      .reduce((total, quantity) => {
        total += quantity;
        return total;
      }, 0);

    const futureStockQuantity = product.stock
      .filter((stock) => stock.type === 'future')
      .map((stock) => stock.quantity)
      .reduce((total, quantity) => {
        total += quantity;
        return total;
      }, 0);

    return currentStockQuantity + futureStockQuantity > 0;
  }

  return false;
}
